<template>
  <main class="neurology__main" id="main">
    <section class="section_outer section_bread_crumbs">
      <div class="section_inner">
        <div class="section_wrapper">
          <div class="bread_crumbs__main">
            <router-link to="/">Медицинская клиника «ПРОЗДОРОВЬЕ»</router-link>
          </div>
          <div class="bread_crumbs__separator">/</div>
          <div class="bread_crumbs__main">
            <router-link to="/services">Услуги</router-link>
          </div>
          <div class="bread_crumbs__separator">/</div>
          <div class="bread_crumbs__next">Неврология</div>
        </div>
      </div>
    </section>
    <section class="section_outer section_service_item">
      <div class="section_inner">
        <div class="section_wrapper">
          <div class="section__title">Неврология</div>
          <div class="service_item__wrapper">
            <img
              class="service_item__image"
              src="../../../../public/img/neurology.png"
              alt=""
            />
            <div class="service_item__info">
              <div class="service_item__title">
                Профилактика, обнаружение, лечение заболеваний центральной и
                периферической нервной системы.
              </div>
              <div class="service_item__description">
                Неврология — медицинское направление, которое изучает
                патологические изменения в центральной и периферической нервной
                системе человека. С чем часто сталкивается врач-невролог — это
                боль, которая влияет на нормальный ритм жизни человека и
                является следствием многих осложнений и появлений целого ряда
                синдромов и симптомов.
              </div>
              <div class="service_item__description">
                Неврологи занимаются ведением и восстановлением пациентов после
                инсультов, черепно-мозговых травм, инфекционных заболеваний
                центральной нервной системы, перенесенных нейрохирургических
                операций.
              </div>
              <button class="aright__signup" @click="openRecordModal">
                Записаться онлайн
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section_outer section_subscribe">
      <div class="section_inner">
        <div class="section_wrapper">
          <div class="section__title">
            Запишитесь на приём более удобным для Вас способом
          </div>
          <ul class="subscribe__list">
            <a :href="`tel:${main_phone_number}`" class="subscribe__call">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M38.1976 29.1372L32.2662 24.0935C32.2388 24.0703 32.2098 24.049 32.1795 24.0297C30.6235 23.0391 28.6255 23.2586 27.3208 24.5629L24.0869 27.7965C23.8629 28.0208 23.5287 28.087 23.2358 27.9662C19.584 26.4556 16.5842 24.1814 14.3194 21.2075C12.5925 18.9397 11.9699 17.1376 11.8878 16.8837C11.878 16.8294 11.8625 16.7754 11.8405 16.7226C11.7193 16.4296 11.7856 16.0961 12.0102 15.8721L15.2438 12.6375C16.5484 11.3329 16.7676 9.33491 15.777 7.77882C15.769 7.76631 15.7608 7.7541 15.7522 7.74189L11.4688 1.78944C10.1211 -0.30132 7.18565 -0.617177 5.42388 1.1443L4.77629 1.79188C4.77599 1.79249 4.77538 1.7931 4.77477 1.79341L2.46276 4.10542C-0.294202 6.86268 -0.745252 11.0057 1.15874 16.0875C2.7896 20.4406 6.05437 25.2047 10.3515 29.5018C14.7504 33.9006 19.6432 37.2258 24.1287 38.8649C28.5684 40.4869 33.291 40.6868 36.6336 37.3439L38.8141 35.1638C40.5679 33.4096 40.2618 30.4934 38.1976 29.1372ZM31.2982 25.3209L37.2244 30.3603C37.2516 30.3835 37.2806 30.4049 37.3108 30.4241C38.5766 31.23 38.7683 33.0001 37.709 34.059L37.5473 34.2211L27.4396 26.6533L28.4256 25.6676C29.1961 24.8967 30.3705 24.7573 31.2982 25.3209ZM10.1636 2.6479C10.1715 2.66041 10.1797 2.67292 10.1883 2.68482L14.4699 8.63514C15.0516 9.56623 14.917 10.7549 14.1391 11.5328L13.1836 12.4886L6.3452 2.43244L6.52861 2.24903C7.59215 1.1855 9.36064 1.38661 10.1636 2.6479ZM24.6646 37.3973C20.3885 35.8348 15.6976 32.6384 11.4563 28.3971C7.31322 24.2543 4.17571 19.688 2.62145 15.5394C1.45476 12.4254 0.671984 8.10566 3.56749 5.21046L5.22063 3.55702L12.059 13.6132L10.9057 14.767C10.2496 15.4219 10.0433 16.3912 10.3708 17.2542C10.6174 18.2662 11.752 20.3667 12.8967 21.9146C14.5813 24.1924 17.6388 27.3415 22.6385 29.41C23.5171 29.7734 24.519 29.5739 25.1916 28.9016L26.3235 27.7694L36.4313 35.3371L35.5289 36.2392C32.4249 39.3435 27.9077 38.5823 24.6646 37.3973Z"
                  fill="#0DC2B6"
                />
              </svg>
              <div class="subscribe_info">
                <div class="subscribe_info__title">Позвоните по телефону</div>
                <div class="subscribe_info__description">
                  {{ main_phone_number }}
                </div>
              </div>
            </a>
            <li class="subscribe__appointment" @click="openRecordModal">
              <svg
                width="46"
                height="46"
                viewBox="0 0 46 46"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M22.9997 2.3324C21.8446 2.3324 20.9048 3.27216 20.9048 4.42728C20.9048 5.58241 21.8446 6.52217 22.9997 6.52217C24.1548 6.52217 25.0946 5.58241 25.0946 4.42728C25.0946 3.27216 24.1548 2.3324 22.9997 2.3324ZM22.9997 5.17442C22.5877 5.17442 22.2524 4.83922 22.2524 4.42719C22.2524 4.01517 22.5877 3.67996 22.9997 3.67996C23.4117 3.67996 23.7469 4.01517 23.7469 4.42719C23.7469 4.83922 23.4117 5.17442 22.9997 5.17442Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M16.7881 7.3606C16.416 7.3606 16.1143 7.66229 16.1143 8.03442V9.15873C16.1143 9.53086 16.416 9.83256 16.7881 9.83256C17.1602 9.83256 17.4619 9.53086 17.4619 9.15873V8.03442C17.4619 7.66229 17.1602 7.3606 16.7881 7.3606Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M29.2119 7.3606C28.8398 7.3606 28.5381 7.66229 28.5381 8.03442V9.15873C28.5381 9.53086 28.8398 9.83256 29.2119 9.83256C29.584 9.83256 29.8857 9.53086 29.8857 9.15873V8.03442C29.8857 7.66229 29.584 7.3606 29.2119 7.3606Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M24.9772 8.57317C24.697 8.32817 24.2713 8.35683 24.0263 8.63696C23.7775 8.92159 23.4036 9.08492 23.0005 9.08492C22.5974 9.08492 22.2234 8.92168 21.9747 8.63696C21.7298 8.35683 21.3041 8.32817 21.0238 8.57317C20.7436 8.81818 20.7151 9.24376 20.96 9.52399C21.4648 10.1015 22.2085 10.4327 23.0005 10.4327C23.7925 10.4327 24.5362 10.1014 25.041 9.52399C25.286 9.24376 25.2574 8.818 24.9772 8.57317Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M30.4272 27.0857H15.5723C15.2001 27.0857 14.8984 27.3874 14.8984 27.7595C14.8984 28.1317 15.2001 28.4333 15.5723 28.4333H30.4272C30.7994 28.4333 31.1011 28.1317 31.1011 27.7595C31.1011 27.3874 30.7994 27.0857 30.4272 27.0857Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M30.4272 31.1531H15.5723C15.2001 31.1531 14.8984 31.4548 14.8984 31.8269C14.8984 32.1991 15.2001 32.5007 15.5723 32.5007H30.4272C30.7994 32.5007 31.1011 32.1991 31.1011 31.8269C31.1011 31.4548 30.7994 31.1531 30.4272 31.1531Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M30.4272 35.2208H15.5723C15.2001 35.2208 14.8984 35.5225 14.8984 35.8947C14.8984 36.2668 15.2001 36.5685 15.5723 36.5685H30.4272C30.7994 36.5685 31.1011 36.2668 31.1011 35.8947C31.1011 35.5225 30.7994 35.2208 30.4272 35.2208Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M26.811 18.1284H25.0946V16.412C25.0946 16.0398 24.7929 15.7382 24.4208 15.7382H21.5787C21.2066 15.7382 20.9049 16.0398 20.9049 16.412V18.1284H19.1885C18.8163 18.1284 18.5146 18.4301 18.5146 18.8022V21.6444C18.5146 22.0165 18.8163 22.3182 19.1885 22.3182H20.9049V24.0346C20.9049 24.4067 21.2066 24.7084 21.5787 24.7084H24.4208C24.7929 24.7084 25.0946 24.4067 25.0946 24.0346V22.3182H26.811C27.1831 22.3182 27.4848 22.0165 27.4848 21.6444V18.8022C27.4848 18.4301 27.1831 18.1284 26.811 18.1284ZM26.1372 20.9706H24.4208C24.0487 20.9706 23.747 21.2722 23.747 21.6444V23.3608H22.2525V21.6444C22.2525 21.2722 21.9508 20.9706 21.5787 20.9706H19.8623V19.476H21.5787C21.9508 19.476 22.2525 19.1743 22.2525 18.8022V17.0858H23.747V18.8022C23.747 19.1743 24.0487 19.476 24.4208 19.476H26.1372V20.9706Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M36.7214 7.07277H33.8426V6.01378C33.8426 4.89612 32.9333 3.98682 31.8156 3.98682H27.6122C27.2847 1.73515 25.3412 0 23.0002 0C20.6591 0 18.7157 1.73515 18.3881 3.98682H14.1847C13.067 3.98682 12.1577 4.89612 12.1577 6.01378V7.07277H9.27894C7.11991 7.07277 5.36328 8.8293 5.36328 10.9883V42.0844C5.36328 44.2435 7.11982 46 9.27894 46H12.5142C12.8863 46 13.188 45.6983 13.188 45.3262C13.188 44.954 12.8863 44.6523 12.5142 44.6523H9.27894C7.863 44.6523 6.71094 43.5004 6.71094 42.0844V10.9883C6.71094 9.5724 7.86291 8.42043 9.27894 8.42043H12.1577V10.1675H9.27894C8.82631 10.1675 8.45813 10.5357 8.45813 10.9883V42.0844C8.45813 42.5371 8.82631 42.9052 9.27894 42.9052H36.7214C37.174 42.9052 37.5422 42.5371 37.5422 42.0844V10.9883C37.5422 10.5357 37.1739 10.1675 36.7214 10.1675H33.8426V8.42043H36.7214C38.1373 8.42043 39.2894 9.5724 39.2894 10.9883V42.0844C39.2894 43.5004 38.1374 44.6523 36.7214 44.6523H15.2095C14.8374 44.6523 14.5357 44.954 14.5357 45.3262C14.5357 45.6983 14.8374 46 15.2095 46H36.7214C38.8804 46 40.637 44.2435 40.637 42.0844V10.9883C40.637 8.8293 38.8805 7.07277 36.7214 7.07277ZM36.1945 11.5153V41.5576H9.80579V11.5152H12.1577V11.6593C12.1577 12.7769 13.067 13.6863 14.1847 13.6863H27.2486C27.6207 13.6863 27.9224 13.3846 27.9224 13.0124C27.9224 12.6403 27.6207 12.3386 27.2486 12.3386H14.1847C13.8101 12.3386 13.5054 12.0339 13.5054 11.6593V6.01378C13.5054 5.63922 13.8101 5.33447 14.1847 5.33447H19.0134C19.3856 5.33447 19.6873 5.03278 19.6873 4.66064C19.6872 2.83385 21.1734 1.34766 23.0002 1.34766C24.8269 1.34766 26.3131 2.83385 26.3131 4.66064C26.3131 5.03278 26.6148 5.33447 26.987 5.33447H31.8156C32.1902 5.33447 32.4949 5.63922 32.4949 6.01378V11.6594C32.4949 12.0339 32.1902 12.3387 31.8156 12.3387H29.9439C29.5718 12.3387 29.2701 12.6404 29.2701 13.0125C29.2701 13.3847 29.5718 13.6863 29.9439 13.6863H31.8156C32.9333 13.6863 33.8426 12.777 33.8426 11.6594V11.5153H36.1945Z"
                  fill="#0DC2B6"
                />
              </svg>

              <div class="subscribe_info">
                <div class="subscribe_info__title">Нажмите чтобы</div>
                <div class="subscribe_info__description">
                  ЗАПИСАТЬСЯ НА ПРИЁМ
                </div>
              </div>
            </li>
            <li
              class="subscribe__tel"
              @click="$store.commit('toggleRecordModalState', 'phoneModal')"
            >
              <svg
                width="41"
                height="40"
                viewBox="0 0 41 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.890672 12.5245C1.12886 13.4021 1.9292 14.0085 2.83851 14.0004C2.9696 14.0004 3.10045 13.9879 3.22919 13.963L7.26892 13.1884L10.3767 12.5064C11.3996 12.3225 12.1031 11.3749 11.9832 10.3426L11.6039 7.43409C11.5566 7.07208 12.3865 6.67078 13.1605 6.55415C17.647 5.82826 22.22 5.81638 26.7102 6.51884C27.9441 6.73148 28.2167 6.92951 28.2754 7.00349C28.3994 7.30964 28.4175 7.64845 28.3267 7.96608L28.0547 9.89931C27.9018 10.5244 28.0104 11.1847 28.3554 11.7279C28.8386 12.2384 29.4913 12.5552 30.1913 12.6191C30.6579 12.7084 31.0173 12.7984 31.3765 12.8858C31.7578 12.9804 32.1385 13.075 32.6344 13.1697L36.2482 13.867C36.8766 14.0523 37.55 14.0132 38.1527 13.7563C38.7871 13.3475 39.198 12.6694 39.2666 11.9178L39.2887 11.8211C39.3587 11.5132 39.4513 11.2078 39.544 10.9025C39.8078 10.1702 39.95 9.39958 39.9653 8.62135C39.8577 7.24988 39.2255 5.9727 38.2001 5.05557C33.5844 0.525249 25.6009 0.0012207 20.0013 0.0012207C7.2176 0.00129882 2.34659 3.68105 0.511322 6.76819C0.00729311 7.6222 -0.131135 8.6433 0.127363 9.60066L0.890672 12.5245ZM1.65664 7.4508C3.3152 4.65966 7.84419 1.33457 20.0014 1.33457C25.3697 1.33457 33.0006 1.81922 37.2669 6.00692C38.0425 6.68461 38.5299 7.63298 38.6295 8.65807C38.6062 9.29295 38.4829 9.92017 38.2642 10.5166C38.1635 10.85 38.0642 11.1866 37.9855 11.5245L37.9622 11.6258C37.8509 12.1218 37.7622 12.4558 37.5336 12.5751C37.194 12.6676 36.835 12.6611 36.4989 12.5564L32.8878 11.8672C32.4212 11.7779 32.0606 11.6879 31.7013 11.6005C31.32 11.5058 30.9393 11.4112 30.4447 11.3166C30.1254 11.2552 29.5901 11.1532 29.4201 10.9286C29.313 10.6621 29.298 10.3674 29.3775 10.0913L29.6501 8.1581C29.8092 7.50799 29.7088 6.82147 29.3701 6.24424C28.9394 5.63093 27.9468 5.38563 26.9396 5.21166C22.3083 4.48491 17.5912 4.49522 12.9632 5.24236C11.5046 5.46367 10.1107 6.28229 10.284 7.61353L10.664 10.5213C10.6915 10.8607 10.4488 11.1623 10.1114 11.2079L7.0023 11.8832L2.97858 12.6538C2.63079 12.7323 2.28152 12.5286 2.17863 12.1872L1.41798 9.2674C1.24987 8.6544 1.33588 7.99952 1.65664 7.4508Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M39.8798 30.4332C39.8732 30.4159 39.8664 30.3992 39.8591 30.3839C39.7968 30.2182 39.7132 30.0614 39.6104 29.9173L31.137 18.4181C30.6331 17.7373 29.8369 17.335 28.9898 17.3335H27.2566L26.6673 12.6185C26.6411 11.9012 26.0518 11.3334 25.334 11.3339H23.3342C22.5978 11.3339 22.0009 11.9308 22.0009 12.6671V18.0001C22.0009 18.3683 22.2993 18.6667 22.6675 18.6667C23.0357 18.6667 23.3341 18.3683 23.3341 18.0001V12.6671H25.334C25.3337 12.6948 25.3355 12.7224 25.3393 12.7498L26.0059 18.0828C26.0476 18.4164 26.331 18.6667 26.6672 18.6667H28.9897C29.413 18.6674 29.8111 18.8684 30.0629 19.2087L38.0137 29.9993H32.6668C32.2986 29.9993 32.0002 30.2978 32.0002 30.6659C32.0002 31.0341 32.2986 31.3325 32.6668 31.3325H38.6664V36.6655C38.6664 37.77 37.771 38.6654 36.6665 38.6654H3.33558C2.23112 38.6654 1.33571 37.7701 1.33571 36.6655V31.3325H29.3339C29.702 31.3325 30.0005 31.034 30.0005 30.6659C30.0005 30.2978 29.702 29.9993 29.3339 29.9993H1.98833L9.93913 19.2087C10.191 18.8684 10.589 18.6674 11.0124 18.6667H13.3349C13.6711 18.6667 13.9546 18.4163 13.9962 18.0828L14.6628 12.7498C14.6665 12.7224 14.6683 12.6948 14.6681 12.6671H16.668V18.0001C16.668 18.3683 16.9664 18.6667 17.3346 18.6667H20.001C20.3692 18.6667 20.6676 18.3683 20.6676 18.0001C20.6676 17.632 20.3692 17.3335 20.001 17.3335H18.0012V12.6672C18.0012 11.9309 17.4043 11.3339 16.6679 11.3339H14.668C13.9503 11.3335 13.361 11.9012 13.3348 12.6185L12.7461 17.3335H11.0129C10.1668 17.3359 9.37166 17.738 8.86834 18.4182L0.391791 29.9179C0.288438 30.0617 0.20485 30.2186 0.143135 30.3846C0.135792 30.3992 0.129152 30.4159 0.122433 30.4325C0.0443917 30.6478 0.00384756 30.8748 0.00244141 31.1038V36.6655C0.00462876 38.5053 1.49562 39.9963 3.33558 39.9986H36.6667C38.5066 39.9964 39.9976 38.5054 39.9999 36.6655V31.1038C39.9985 30.8751 39.9579 30.6483 39.8798 30.4332Z"
                  fill="#0DC2B6"
                />
                <path
                  d="M15.6083 22.3244C16.2222 21.9968 16.878 21.7543 17.5574 21.6038C19.1669 21.2445 20.8357 21.2445 22.4451 21.6038C22.6775 21.659 22.9217 21.5856 23.0852 21.4114C23.2487 21.2372 23.3064 20.9888 23.2366 20.7603C23.1668 20.5319 22.98 20.3582 22.747 20.3052C20.9389 19.9005 19.0636 19.9005 17.2554 20.3052C16.4572 20.4834 15.687 20.7695 14.9662 21.1559C14.3343 21.4866 13.7774 21.9441 13.3303 22.4997C12.4465 23.5621 12.4465 25.1038 13.3303 26.1662C13.7774 26.7218 14.3343 27.1794 14.9662 27.51C15.6871 27.8963 16.4572 28.1824 17.2554 28.3607C19.0633 28.7678 20.9391 28.7678 22.747 28.3607C23.5452 28.1825 24.3154 27.8963 25.0362 27.51C25.6681 27.1793 26.225 26.7218 26.6721 26.1662C27.5558 25.1038 27.5558 23.5621 26.6721 22.4997C26.529 22.3052 26.2917 22.2033 26.052 22.2334C25.8124 22.2634 25.6078 22.4208 25.5172 22.6447C25.4265 22.8686 25.4642 23.1241 25.6154 23.3124C26.1291 23.8958 26.1291 24.7701 25.6154 25.3535C25.279 25.7617 24.8636 26.0978 24.3942 26.3415C23.7802 26.6691 23.1244 26.9116 22.445 27.0621C20.8356 27.4214 19.1667 27.4214 17.5574 27.0621C16.8781 26.9117 16.2225 26.6692 15.6088 26.3415C15.1391 26.0979 14.7234 25.7619 14.3869 25.3535C13.8732 24.7701 13.8732 23.8958 14.3869 23.3124C14.7234 22.9042 15.1388 22.5682 15.6083 22.3244Z"
                  fill="#0DC2B6"
                />
              </svg>

              <div class="subscribe_info">
                <div class="subscribe_info__title">Нажмите, чтобы получить</div>
                <div class="subscribe_info__description">ОБРАТНЫЙ ЗВОНОК</div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="section_outer section_service_cost">
      <div class="section_inner">
        <div class="section_wrapper">
          <div class="service_cost__left">
            <div class="service_cost__title">
              Неврология — Прейскурант ООО МДЦ «ПРОЗДОРОВЬЕ»
            </div>
            <div class="service_cost__bottom">
              <p>Мы рады помочь Вам по всем вопросам — звоните!</p>
              <a :href="`tel:${main_phone_number}`">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.5432 11.3061L12.0431 9.80686C11.8937 9.7431 11.7276 9.72963 11.5699 9.76848C11.4121 9.80733 11.2712 9.8964 11.1683 10.0223L9.61825 11.9159C7.18686 10.7701 5.2292 8.8122 4.08115 6.37813L5.97485 4.82824C6.10104 4.72579 6.19039 4.58486 6.22932 4.42687C6.26825 4.26888 6.25463 4.10247 6.19052 3.95294L4.69041 0.453035C4.61991 0.291798 4.49551 0.160233 4.33863 0.0809949C4.18175 0.00175651 4.00221 -0.0201974 3.83092 0.0189132L0.581101 0.768527C0.415991 0.806539 0.268626 0.899529 0.163079 1.03231C0.0575318 1.16508 4.16567e-05 1.3298 0 1.49955C0.00159593 3.4057 0.377944 5.29286 1.10755 7.05325C1.83715 8.81364 2.90572 10.4128 4.25222 11.7593C5.59872 13.1059 7.19678 14.1734 8.95512 14.9011C10.7135 15.6287 12.5976 16.0021 14.5 16C14.6695 16.0003 14.8342 15.9431 14.9671 15.8376C15.0999 15.732 15.1931 15.5845 15.2315 15.419L15.9816 12.1692C16.0202 11.9969 15.9977 11.8164 15.9177 11.659C15.8378 11.5015 15.7056 11.3769 15.5438 11.3067L15.5432 11.3061Z"
                    fill="#0DC2B6"
                  />
                </svg>
                {{ main_phone_number }}
              </a>
            </div>
          </div>
          <a
            :href="priceList?.neurology_price_list"
            class="cost_right"
            target="_black"
            >Стоимость услуг</a
          >
        </div>
      </div>
    </section>
    <section class="section_outer section_service_text">
      <div class="section_inner">
        <div class="section_wrapper">
          <div class="section__title">Неврология ООО МДЦ «ПРОЗДОРОВЬЕ»</div>
          <ol class="service_text__number_list">
            <li class="service_text__number_item">
              <p class="service_text__number_paragraf">
                Врач невролог сопровождает пациента на протяжении всех этапов
                его лечения и даёт необходимые советы посредством консультаций.
              </p>
              <p class="service_text__number_paragraf margin">
                Для поддержания здоровья организма необходима постоянная
                профилактика заболеваний нервной системы, которая заключается в
                поддержании активного, здорового образа жизни и прохождении
                осмотра на приеме у врача-невролога, не реже 1 раз в год (в
                зависимости от возраста и состояния нервной системы пациента).
              </p>
            </li>
            <li class="service_text__number_item">
              <p class="service_text__number_title">
                Когда необходима консультация врача невролога:
              </p>
              <ul>
                <li class="service_text__number_paragraf">
                  головокружение;
                </li>
                <li class="service_text__number_paragraf">
                  шум в ушах;
                </li>
                <li class="service_text__number_paragraf">
                  обмороки;
                </li>
                <li class="service_text__number_paragraf">
                  слабость;
                </li>
                <li class="service_text__number_paragraf">
                  онемение конечностей;
                </li>
                <li class="service_text__number_paragraf">
                  нарушения двигательной активности (неустойчивость, шаткость
                  походки);
                </li>
                <li class="service_text__number_paragraf">
                  травма головы.
                </li>
              </ul>
              <p class="service_text__number_paragraf margin">
                Не медлите с записью на прием к неврологу, если Вы заметили у
                себя нарушение сна, постоянные головные боли и головокружение,
                общую вялость и хроническую усталость, слабость конечностей ,
                нарушение равновесия при ходьбе и координации движений,
                затрудненную ориентацию в пространстве, снижение памяти и
                периодические потери сознания, слабость, тики и судороги,
                онемение различных участков тела, шум в ушах, ухудшение слуха,
                зрения и обоняния. Кроме того, любая черепно – мозговая травма
                является поводом обратиться к неврологу. Дело в том, что ее
                последствия могут проявиться спустя некоторое время и привести к
                серьезным осложнениям. Только квалифицированный специалист
                способен распознать неврологическое заболевание на любой стадии
                и назначить правильное и эффективное лечение.
              </p>
              <p class="service_text__number_paragraf">
                Кроме того, неврологи медицинского центра «ПРОЗДОРОВЬЕ»
                занимается лечением проблем, связанных с нарушениями сна, частой
                сменой настроения, эмоций и поведения. На практике встречается,
                что врач выявляет симптомы, которые не являются предметом
                изучения неврологии в этом случае необходима консультация и
                вмешательства врачей других специальностей (кардиолога и др.).
              </p>
              <p class="service_text__number_paragraf margin">
                В клинике «ПРОЗДОРОВЬЕ» ведут прием высококвалифицированные
                врачи-неврологи, имеющие большой опыт работы в стационаре.
              </p>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <section class="section_outer section_service_med">
      <div class="section_inner">
        <div class="section_wrapper">
          <div class="section__title">
            Неврологи ООО МДЦ «ПРОЗДОРОВЬЕ»
          </div>
          <ul class="service_med__list">
            <li
              class="service_med__item"
              :key="index"
              v-for="(doctor, index) in dataService?.doctors.filter(
                (item) => item.is_shown
              )"
            >
              <img :src="doctor.photo" alt="" />
              <div
                class="service_med__item_name"
                v-html="`${doctor.surname} ${doctor.name} ${doctor.patronymic}`"
              ></div>
              <div
                class="service_med__item_work"
                v-html="doctor.position"
              ></div>
              <div class="service_med__item_date">
                {{ doctor.experience }}
              </div>
              <button
                class="service_med__item_button"
                @click="doctorOpenModal(doctor)"
              >
                Записаться
              </button>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "neurology",
  props: ["main_phone_number", "priceList", "servicesList"],
  data() {
    return {
      title: "Неврология",
    };
  },
  computed: {
    dataService() {
      return this.servicesList
        ? this.servicesList.find((item) => item.name === this.title)
        : null;
    },
  },
  methods: {
    openRecordModal() {
      this.$store.commit("updateRecordModalValues", {
        keyModal: "selectedCategory",
        valueModal: this.dataService,
      });
      this.$store.commit("toggleRecordModalState", "recordModal");
    },
    doctorOpenModal(doctor) {
      this.$store.commit("toggleRecordModalState", "recordModal");
      this.$store.commit("updateRecordModalValues", {
        keyModal: "selectedCategory",
        valueModal: this.dataService,
      });
      this.$store.commit("updateRecordModalValues", {
        keyModal: "selectedDoctor",
        valueModal: doctor,
      });
    },
  },
};
</script>

<style scoped></style>
